<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import { onBeforeMount } from 'vue'
import { useStore } from 'vuex'

export default {
  name: "MainApp",
  setup() {
    const store = useStore()

    onBeforeMount(() => {
      store.dispatch('fetchUser')
    })
  },
};
</script>

<style src="./assets/css/style.css"></style>
<style lang="scss">@import './assets/styles/global.scss';</style>
